import { brand } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
var styles = CustomStyleSheet({
  transactionList: {
    paddingHorizontal: 12
  },
  transactionItem: {
    width: 236,
    borderRadius: 6,
    marginRight: 8,
    backgroundColor: '#fff'
  },
  moreBtn: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 122,
    padding: 12,
    backgroundColor: '#fff',
    borderRadius: 6
  },
  moreBtnImage: {
    width: 29,
    height: 29
  },
  moreBtnText: {
    marginTop: 10,
    fontSize: 14,
    lineHeight: 17,
    color: brand,
    textAlign: 'center'
  },
  transactionConsult: {
    flexDirection: 'row',
    height: 44,
    width: 360,
    paddingHorizontal: 8,
    justifyContent: 'center'
  },
  consultMessage: {
    lineHeight: 44,
    marginRight: 8,
    fontSize: 12,
    color: '#595959'
  },
  consultLink: {
    lineHeight: 44,
    fontSize: 12,
    color: '#2673dd'
  },
  transactionVerticalListContainer: {
    flex: 1,
    backgroundColor: '#EFEFEF'
  },
  transactionVerticalList: {
    paddingBottom: 11
  },
  transactionVerticalWrapper: {
    marginTop: 11
  },
  footerContainer: {
    alignItems: 'center',
    padding: 8,
    backgroundColor: '#FFF'
  },
  footerText: {
    width: 360,
    height: 44,
    lineHeight: 44,
    textAlign: 'center',
    borderWidth: 1,
    borderColor: brand,
    color: brand
  }
});
export default styles;